var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#57B757",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 19.441C18.3996 18.8478 17.3654 18.5 16.2499 18.5C13.553 18.5 11.331 20.5335 11.0337 23.151C11.0127 23.3362 11.0022 23.4288 11.0392 23.5183C11.0694 23.5914 11.1349 23.6648 11.2042 23.7031C11.2889 23.75 11.3926 23.75 11.5999 23.75H15.4585M19.2499 13.25C19.2499 14.9069 17.9068 16.25 16.2499 16.25C14.5931 16.25 13.2499 14.9069 13.2499 13.25C13.2499 11.5931 14.5931 10.25 16.2499 10.25C17.9068 10.25 19.2499 11.5931 19.2499 13.25Z",
    stroke: "#57B757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 20V21.5",
    stroke: "#57B757",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23H20",
    stroke: "#57B757",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.95 20.75H18.5C18.0858 20.75 17.75 21.0858 17.75 21.5V24.5C17.75 24.9142 18.0858 25.25 18.5 25.25H23C23.4142 25.25 23.75 24.9142 23.75 24.5V21.5C23.75 21.0858 23.4142 20.75 23 20.75H21.75",
    stroke: "#57B757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrHub);
export default __webpack_public_path__ + "static/media/hr-hub.7cc0a6c25b025a2af3e1d4e86068392d.svg";
export { ForwardRef as ReactComponent };